import React from 'react';
import { motion } from 'framer-motion';
import '../styles/components/TextReveal.css';

const TextReveal = ({ 
  text, 
  className = '', 
  delay = 0,
  once = true,
  staggerChildren = 0.08,
  childDuration = 0.8,
  blurAmount = 10,
  inline = false 
}) => {
  const lines = text.split(/\n|<br\s*\/?>/);

  const container = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { 
        staggerChildren: staggerChildren, 
        delayChildren: delay 
      },
    },
  };

  const child = {
    hidden: {
      y: "100%", // Slide up from below
      opacity: 0,
      filter: `blur(${blurAmount}px)` 
    },
    visible: {
      y: 0,
      opacity: 1,
      filter: `blur(0px)`,
      transition: {
        type: "spring",
        damping: 25,
        stiffness: 150,
        duration: childDuration,
      },
    },
  };

  // If inline is true, use SPAN. If false, use DIV.
  const ContainerElement = inline ? motion.span : motion.div;
  const LineWrapperElement = inline ? 'span' : 'div';
  const ContentElement = inline ? 'span' : 'div';

  return (
    <ContainerElement
      className={`text-reveal-container ${className} ${inline ? 'inline-mode' : ''}`}
      variants={container}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: once, margin: "-50px", amount: 0.2 }}
    >
      {lines.map((line, lineIndex) => (
        <LineWrapperElement 
          key={lineIndex} 
          className="text-reveal-line-wrapper"
        >
          <ContentElement
            variants={child}
            className="text-reveal-line-content"
          >
            {line}
          </ContentElement>
        </LineWrapperElement>
      ))}
    </ContainerElement>
  );
};

export default TextReveal;